import React, { memo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import RoundedPagination from 'pages/Pagination';
import { DEFAULT_PAGE_SIZE } from 'constants/configConstants';
import { noDataFoundStyles } from 'pages/ocplcDashboard/ocplcHelpers';
import { dataGridStyles } from './DashboardHelpers';

const TableGrid = ({
  columns,
  rows,
  tableData,
  isLoading,
  checkedRows,
  onRowClick,
  onRowSelection,
  rowSelectionModel,
  onRowSelectionModelChange
}) => {

  if (!isLoading && tableData?.length === 0) {
    return <div style={noDataFoundStyles}>No data found</div>;
  }

  // Prefer rowSelectionModel/onRowSelectionModelChange if provided, else fallback to checkedRows/onRowSelection
  const selectionModel = rowSelectionModel !== undefined
    ? rowSelectionModel
    : checkedRows?.map((row) => row.pkId);

  const selectionChangeHandler = onRowSelectionModelChange || onRowSelection;

  return (
    <DataGrid
      columns={columns}
      rows={rows}
      getRowId={(row) => row.pkId || `${row.version}-${row.region}-${row.productFamily}-${row.country}-${Math.random()}`}
      rowHeight={48}
      loading={isLoading}
      columnHeaderHeight={90}
      onRowClick={onRowClick}
      checkboxSelection
      rowSelectionModel={selectionModel}
      onRowSelectionModelChange={selectionChangeHandler}
      slots={{ pagination: RoundedPagination }}
      getRowClassName={(params) =>
        `${params.indexRelativeToCurrentPage % 2 === 0 ? 'evenRow' : 'oddRow'}`
      }
      headerClassName="dashboard-grid-headers"
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: DEFAULT_PAGE_SIZE },
        },
      }}
      sx={dataGridStyles}
      disableColumnFilter
      disableColumnMenu
    />
  );
};

export default memo(TableGrid);
